import React, {type PropsWithChildren} from "react";
import {Spin} from "antd";
import useMatomo from "../../../hooks/useMatomo";

type MatomoWrapperProps = PropsWithChildren

export default function MatomoWrapper({children}: MatomoWrapperProps) {
  const {isConfigLoading} = useMatomo();

  if (isConfigLoading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          width: '100vw',
        }}
      >
        <Spin
          size="large"
        />
      </div>
    );
  }

  return <>{children}</>;
}
